export default __webpack_public_path__ + "static/media/work-1.1f43315a.png";